<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['staff_mgt'] == 1">
      <div class="row">
        <div class="col-12">
          <div class="card shadow-lg">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-b-modal.new-staffload size="sm" variant="primary"
                  ><i class="mdi mdi-plus"></i> New Staff Load</b-button
                >
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show
                      <b-form-select
                        class="form-select form-select-sm mx-1"
                        v-model="perPage"
                        size="sm"
                        :options="Options"
                      ></b-form-select>
                      entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                  >
                    <label class="d-inline-flex align-items-center">
                      Search:
                      <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                      ></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                  <template #table-busy
                    ><div class="text-center text-primary my-2">
                      <b-spinner
                        class="align-middle"
                        type="grow"
                        small
                      ></b-spinner>
                      <strong>No Data Found</strong>
                    </div></template
                  >
                  <template #cell(index)="data">
                    {{ data.index + 1 }}
                  </template>
                  <template #cell(user)="data">
                    {{ data.item.user.full_name }}
                  </template>
                  <template #cell(schoolclass)="data">
                    <b class="text-danger">{{ data.item.schoolclass.name }}</b>
                    <br />
                  </template>
                  <template #cell(schoolsubject)="data">
                    {{ data.item.schoolsubject.name }}
                  </template>
                  <template #cell(actions)="data">
                    <div class="btn-group">
                      <b-button
                        @click="
                          edit(
                            data.item.id,
                            data.item.class.id,
                            data.item.subject,
                            data.item.user,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="primary"
                        v-b-modal.edit
                      >
                        <i class="mdi mdi-square-edit-outline"></i>
                      </b-button>
                      <b-button
                        @click="
                          remove(
                            data.item.id,
                            data.item.class.name,
                            data.item.user.full_name,
                          )
                        "
                        type="button"
                        class="btn-sm btn"
                        variant="danger"
                        v-b-modal.delete
                      >
                        <i class="mdi mdi-trash-can"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="List"
                        :per-page="perPage"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal
        id="new-staffload"
        centered
        title="New Staff Load"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="addStaffLoad">
          <div class="form-group mb-2">
            <label>Staff</label>
            <v-select
              :options="staffmembers"
              placeholder="Select User"
              label="full_name"
              v-model="user"
              :reduce="(staffmembers) => staffmembers.id"
            ></v-select>
            <!-- <v-select :options="users" placeholder="Select User" label="username" v-model="user" :reduce="users => users.id"></v-select> -->
            <label>Class</label>
            <v-select
              :options="schoolclasses"
              @input="FindSubject()"
              placeholder="Select Class"
              label="name"
              v-model="schoolclass"
              :reduce="(schoolclasses) => schoolclasses.id"
            ></v-select>
            <label>Subject</label>
            <multiselect
              v-model="schoolsubject"
              label="name"
              :options="schoolsubjects"
            ></multiselect>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('new-staffload')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="edit-staffload"
        centered
        title="Edit Staff Load"
        title-class="font-14"
        hide-footer
      >
        <form @submit.prevent="editStaffLoad">
          <div class="form-group mb-2">
            <input v-model="id" type="hidden" />
            <label>Staff</label>
            <v-select
              :options="staffmembers"
              placeholder="Select User"
              label="full_name"
              v-model="user"
              :reduce="(staffmembers) => staffmembers.id"
            ></v-select>
            <!-- <v-select :options="users" placeholder="Select User" label="username" v-model="user" :reduce="users => users.id"></v-select> -->
            <label>Class</label>
            <v-select
              :options="schoolclasses"
              @input="FindSubject()"
              placeholder="Select Class"
              label="name"
              v-model="schoolclass"
              :reduce="(schoolclasses) => schoolclasses.id"
            ></v-select>
            <label>Subject</label>
            <multiselect
              v-model="schoolsubject"
              label="name"
              :options="schoolsubjects"
            ></multiselect>
          </div>
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('edit-staffload')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> Submit</b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
        id="delete-staffload"
        centered
        title="Delete Staff Load"
        title-class="font-18"
        hide-footer
      >
        <form @submit.prevent="removeStaffLoad">
          <input v-model="id" type="hidden" />
          Are you sure you want to delete the Staff Load :
          <b>{{ schoolclass }} - {{ user }} </b> ?
          <div class="form-group d-flex justify-content-end">
            <b-button
              type="button"
              class="btn w-30"
              variant="secondary"
              @click="$bvModal.hide('delete-staffload')"
              >Close</b-button
            >
            <b-button type="submit" class="btn ms-1 w-30" variant="primary"
              ><i class="fas fa-check-circle"></i> YES</b-button
            >
          </div>
        </form>
      </b-modal>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <center>
              <span class="text-primary h4"
                >You have no permission to view this Page.</span
              >
            </center>
            <img
              src="@/assets/images/profile-img.png"
              alt
              class="img-fluid"
            /><br /><br />
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  schoolclassComputed,
  schoolclassMethods,
  staffloadComputed,
  staffloadMethods,
  staffmemberComputed,
  staffmemberMethods,
  userComputed,
  userMethods,
} from "@/state/helpers";
import axios from "axios";
import Multiselect from "vue-multiselect";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Staff Load",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Staff Load",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Staff Load", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "user", label: "Staff", visible: true },
        { key: "schoolclass", label: "Class", visible: true },
        { key: "schoolsubject", label: "Subject", visible: true },
        { key: "actions", label: "Actions", visible: true },
      ],
      id: "",
      schoolclass: "",
      schoolsubjects: [],
      schoolsubject: "",
      user: "",
      name: "",
      full_name: "",
    };
  },
  computed: {
    ...userComputed,
    ...schoolclassComputed,
    ...staffloadComputed,
    ...staffmemberComputed,
    List() {
      return this.staffloads.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.staffloads.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.staffloads.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchSchoolClasses();
    this.fetchStaffLoads();
    this.fetchUsers();
    this.fetchStaffMembers();
    this.TotalRows = this.staffloads.length;
    this.isBusy = false;
  },
  methods: {
    ...userMethods,
    ...schoolclassMethods,
    ...staffloadMethods,
    ...staffmemberMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id, schoolclass, schoolsubject, user) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.schoolsubject = schoolsubject;
      this.user = user;
      this.$bvModal.show("edit-staffload");
    },
    remove(id, schoolclass, user) {
      this.id = id;
      this.schoolclass = schoolclass;
      this.user = user;
      this.$bvModal.show("delete-staffload");
    },
    async addStaffLoad() {
      let formData = new FormData();
      formData.append("schoolclass", this.schoolclass);
      formData.append("schoolsubject", this.schoolsubject.id);
      formData.append("user", this.user);
      let url = "/addstaffload";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffLoads();
          this.$bvModal.hide("new-staffload");
          this.schoolclass = "";
          this.user = "";
          this.schoolsubject = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async editStaffLoad() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("schoolclass", this.schoolclass);
      formData.append("schoolsubject", this.schoolsubject.id);
      formData.append("user", this.user);
      let url = "/updatestaffload";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffLoads();
          this.$bvModal.hide("edit-staffload");
          this.schoolclass = "";
          this.user = "";
          this.schoolsubject = "";
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async removeStaffLoad() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removestaffload";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchStaffLoads();
          this.$bvModal.hide("delete-staffload");
          this.$swal({
            title: "Success",
            text: response.data.message,
            icon: "success",
          });
        }
      });
    },
    async FindSubject() {
      let url = `/findsubjects/${this.schoolclass}`;
      await axios.get(url).then((response) => {
        this.schoolsubjects = response.data.subjects;
      });
    },
  },
};
</script>
